import React from "react";
import { StoredSubmission } from "@/types/fitconnect.ts";
import { LoadingCard } from "@/components/LoadingCard.tsx";
import { reformatDate } from "@/lib/dateTime.tsx";
import { FileX } from "lucide-react";

function SubmissionCard({
  submission,
  isSelected,
  onSelect,
}: {
  submission: StoredSubmission;
  isSelected: boolean;
  onSelect: () => void;
}) {
  return (
    <button
      onClick={onSelect}
      className={`
                w-full text-left rounded-md border p-3 mb-2
                cursor-pointer
                transition-colors
                hover:bg-gray-50
                focus:outline-none focus:ring-2 focus:ring-blue-500
                ${isSelected ? "border-blue-500 bg-blue-50" : "border-gray-200"}
            `}
    >
      <div className="grid grid-cols-[7rem_1fr] gap-x-3 gap-y-1 text-sm">
        <div className="text-xs text-gray-400">Submission ID</div>
        <div className="font-semibold truncate">{submission.submissionId}</div>

        <div className="text-xs text-gray-400">Case ID</div>
        <div className="truncate text-gray-700">{submission.caseId}</div>

        <div className="text-xs text-gray-400">Destination ID</div>
        <div className="truncate text-gray-700">{submission.destinationId}</div>

        <div className="text-xs text-gray-400">Zeitstempel</div>
        <div className="text-gray-700">
          {reformatDate(submission.submittedAt)}
        </div>
      </div>
    </button>
  );
}

export function StoredSubmissionSelector({
  isLoading,
  submissions,
  selectedId,
  onSelect,
}: {
  isLoading: boolean;
  submissions: StoredSubmission[];
  selectedId: string | null;
  onSelect: (id: StoredSubmission) => void;
}) {
  return (
    <section>
      <div className="card shadow-sm bg-white">
        {isLoading && <LoadingCard />}
        <div className="card-body">
          {submissions.length == 0 && (
            <div className="flex flex-col items-center justify-center text-gray-500">
              <FileX className="h-8 w-8 mb-2" />
              <p className="text-sm">Keine Daten</p>
            </div>
          )}
          {submissions.map((s) => (
            <SubmissionCard
              key={s.submissionId}
              submission={s}
              isSelected={s.submissionId === selectedId}
              onSelect={() => onSelect(s)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
